import { RootState } from '../../rootReducer';

export const textSelectionSelectors = {
  getSelectionState: (state: RootState) => state.TextSelectionState,
};
